import WCCSliderBaseAnimator, { WCCSliderBaseAnimatorConfig } from "./base";

interface WCCSliderSlideAnimatorContext {
    prevShift: number
    offset: number
}

export interface WCCSliderSlideAnimatorConfig { }
export interface WCCSliderSlideAnimatorConfigFull<T> extends WCCSliderBaseAnimatorConfig<T>, WCCSliderSlideAnimatorConfig { }

export default class WCCSliderSlideAnimator<T> extends WCCSliderBaseAnimator<T, WCCSliderSlideAnimatorContext> {
    constructor(config: WCCSliderSlideAnimatorConfigFull<T>) {
        super(config);
    }

    protected getAnimationDuration() {
        return 500;
    }

    protected getAnimationContext() {
        const width = this.width();
        const nextShift = this.nextShift();

        let prevShift = this.shift();
        let offset = nextShift - prevShift;

        if (offset > width) {
            prevShift = nextShift > prevShift ? nextShift - width : nextShift + width;
            offset = width;
        }

        return {
            prevShift: prevShift,
            offset: offset
        }
    }

    protected override onProgress(progress: number, context: WCCSliderSlideAnimatorContext) {
        super.onProgress(progress, context);

        const { offset, prevShift } = context;

        this.shift(prevShift + offset * progress / 100);
    }
}